import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import BottomNav from './BottomNav';
import { useAppStore } from 'context/AppStore';
import HelpAssistant from './HelpAssistant';

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint);
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handler = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [breakpoint]);
  return isMobile;
}

export default function Layout() {
  const { sidebarOpen, toggleSidebar } = useAppStore();
  const { pathname } = useLocation();
  const isMobile = useIsMobile();

  // Cerrar drawer al navegar en móvil
  useEffect(() => {
    if (isMobile && sidebarOpen) toggleSidebar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const showDesktopSidebar = !isMobile && sidebarOpen;
  const showMobileDrawer   =  isMobile && sidebarOpen;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg-base)' }}>

      {/* Overlay detrás del drawer móvil */}
      {showMobileDrawer && (
        <div
          onClick={toggleSidebar}
          style={{
            position: 'fixed', inset: 0,
            background: 'rgba(0,0,0,0.65)',
            backdropFilter: 'blur(3px)',
            WebkitBackdropFilter: 'blur(3px)',
            zIndex: 199,
            cursor: 'pointer',
          }}
        />
      )}

      {/* Sidebar desktop — ocupa espacio en el flex row */}
      {showDesktopSidebar && (
        <div style={{ width: 'var(--sidebar-width)', flexShrink: 0 }}>
          <Sidebar />
        </div>
      )}

      {/* Sidebar drawer móvil — flotante sobre el contenido */}
      {showMobileDrawer && (
        <div
          className="animate-drawerIn"
          style={{
            position: 'fixed',
            top: 0, left: 0, bottom: 0,
            width: 'var(--sidebar-width)',
            zIndex: 200,
          }}
        >
          <Sidebar />
        </div>
      )}

      {/* Contenido principal */}
      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0,
        maxWidth: '100%',
        paddingTop: 'var(--topbar-height)',
      }}>
        <Topbar />
        <main style={{
          flex: 1,
          padding: isMobile ? '16px' : '24px',
          overflowY: 'auto',
          overflowX: 'hidden',
          paddingBottom: isMobile
            ? 'calc(var(--bottom-nav-height) + 16px + env(safe-area-inset-bottom))'
            : '24px',
        }}>
          <Outlet />
        </main>
      </div>

      <BottomNav />
      <HelpAssistant />
    </div>
  );
}
